enum LoginMode {
  Student,
  Startup,
}

export default LoginMode
